import * as React from 'react';
/**
 *
 * Original name: cloud download
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14992%3A16
 *
 */
export const CloudDownloadFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.245 10.005C16.15 7.49 14.579 6 12 6s-4.15 1.492-4.245 4.005C5.242 10.1 3.75 11.67 3.75 14.25c0 2.578 1.492 4.142 4 4.24h8.5c2.509-.1 4-1.664 4-4.24 0-2.575-1.491-4.15-4.005-4.245ZM12.76 11.75v3.739l1.07-1.03 1.04 1.082-2.86 2.75-2.86-2.75 1.04-1.082 1.07 1.03V11.75h1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
